/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ReactElement } from 'react';
import type { EnrichedProductItem } from '@/lib/product/product-utils';
// @sfdc-extension-block-start SFDC_EXT_BOPIS
import { isSiteOutOfStock } from '@/lib/product/inventory-utils';
// @sfdc-extension-block-end SFDC_EXT_BOPIS
// @sfdc-extension-line SFDC_EXT_BOPIS
import BopisCartDeliveryOption from '@/extensions/bopis/components/delivery-options/cart-delivery-option';

interface CartDeliveryOptionProps {
    product: EnrichedProductItem;
}

export default function CartDeliveryOption(_props: CartDeliveryOptionProps): ReactElement | null {
    const adapter = { value: null as ReactElement | null };
    // @sfdc-extension-block-start SFDC_EXT_BOPIS
    const product = {
        ..._props.product,
        id: _props.product.id || _props.product.productId || '',
    };
    const isDeliveryOutOfStock = isSiteOutOfStock(product, _props.product.quantity ?? 1);
    adapter.value = <BopisCartDeliveryOption {..._props} isDeliveryOutOfStock={isDeliveryOutOfStock} />;
    // @sfdc-extension-block-end SFDC_EXT_BOPIS
    return adapter.value;
}
